import { FC } from "react";
import { useSelector } from "react-redux";

import { selectDrawingInstances } from "../model";
import type { DrawingToolName } from "../model";
import { TOOLS } from "./config";
import { SettingsToolIcon } from "shared/ui";

import styles from "./styles/SelectDrawingTool.module.css";

interface Props {
  onToolClick: (id: string, name: DrawingToolName, label: string) => void;
}

export const CurrentToolsList: FC<Props> = ({ onToolClick }) => {
  const instances = useSelector(selectDrawingInstances);

  if (instances.length === 0) {
    return <p className={styles.empty}>No tools selected</p>;
  }

  const toolOrder = Object.fromEntries(TOOLS.map((t, i) => [t.name, i]));
  const sorted = [...instances].sort(
    (a, b) => (toolOrder[a.name] ?? 0) - (toolOrder[b.name] ?? 0),
  );

  return (
    <ul className={styles.list}>
      {sorted.map((instance) => {
        const tool = TOOLS.find((t) => t.name === instance.name);
        if (!tool) return null;
        return (
          <li
            key={instance.id}
            className={styles.item}
            onClick={() => onToolClick(instance.id, instance.name, tool.label)}
          >
            {tool.icon}
            <span>{tool.label}</span>
            <SettingsToolIcon className={styles.settingsIcon} />
          </li>
        );
      })}
    </ul>
  );
};
